import React from 'react';

export const ChevronTightRight: React.FC<React.SVGProps<SVGSVGElement>> = (
  props,
) => {
  return (
    <svg
      width="8"
      height="27"
      viewBox="0 0 8 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_10485_50130)">
        <path
          d="M1.57112 24.7447L6.83594 13.886L1.57112 3.02734"
          stroke="currentColor"
          strokeOpacity="0.5"
          strokeWidth="2.34783"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_10485_50130">
          <rect
            width="7.50085"
            height="26.1894"
            fill="white"
            transform="translate(0.453125 0.792969)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
